/******************************* 流程引擎控制器 *******************************/
import request from "@/utils/request";

/**
 * @description 复制流程表单
 * @param {string} id
 */
export function copyFlowEngine(id) {
  return request({
    url: "/workflow/engine/flowEngine/actions/copy",
    method: "post",
    data: { id },
  });
}

/**
 * @description 工作流导出
 * @param {string} id
 */
export function exportFlowEngine(id) {
  return request({
    url: "/workflow/engine/flowEngine/actions/exportData",
    method: "post",
    data: { id },
  });
}

/**
 * @description 导入
 */
export function importFlowEngine(data) {
  return request({
    url: "/workflow/engine/flowEngine/actions/importData",
    method: "post",
    data,
  });
}

/**
 * @description 新建流程引擎
 */
export function addFlowEngine(data) {
  return request({
    url: "/workflow/engine/flowEngine/add",
    method: "post",
    data,
  });
}

/**
 * @description 校验名称
 * @param {string} data.id
 * @param {string} [data.name] - 流程名称
 * @param {string} [data.code] - 流程编码
 * @param {string|number} data.userType - 用户类型
 * @param {string} data.systemType - 系统类型
 */
export function checkName(data) {
  return request({
    url: "/workflow/engine/flowEngine/checkName",
    method: "post",
    data,
  });
}

/**
 * @description 流程：清空数据
 * @param {string[]} data.flowIds
 * @param {number} [data.startTime]
 * @param {number} [data.endTime]
 */
export function clearFlow(data) {
  return request({
    url: "/workflow/engine/flowEngine/clearFlow",
    method: "post",
    data,
  });
}

/**
 * @description 批量删除
 * @param {string[]} ids
 */
export function delFlowEngine(ids) {
  return request({
    url: "/workflow/engine/flowEngine/del",
    method: "post",
    data: { ids },
  });
}

/**
 * @description 获取流程引擎信息
 * @param {string} id
 */
export function flowEngineDetail(id) {
  return request({
    url: "/workflow/engine/flowEngine/detail",
    method: "post",
    data: { id },
  });
}

/**
 * @description 流程列表
 */
export function flowEngineList(data) {
  return request({
    url: "/workflow/engine/flowEngine/list",
    method: "post",
    data,
  });
}

/**
 * @description 流程设计下拉框(可见)
 * @param {string} [data.category]
 * @param {string} [data.flowId]
 * @param {string|number} [data.formType] - 表单类型 1-系统表单、2-动态表单 3纯表单 4 调查问卷
 * @param {string|number} [data.type] - 流程类型 1:发起流程,2:功能流程
 * @param {string|number} [data.userType] - 流程使用 1:老师,2:学生 3：其他流程 4：第三方...
 * @param {string} [data.postId]
 * @param {string} [data.systemType]
 */
export function flowEngineListAll(data) {
  return request({
    url: `/workflow/engine/flowEngine/listAll`,
    method: "post",
    data,
  });
}

/**
 * @description 流程设计下拉框(所有)
 * @param {string} [data.category]
 * @param {string} [data.flowId]
 * @param {string|number} [data.formType] - 表单类型 1-系统表单、2-动态表单 3纯表单 4 调查问卷
 * @param {string|number} [data.type] - 流程类型 1:发起流程,2:功能流程
 * @param {string|number} [data.userType] - 流程使用 1:老师,2:学生 3：其他流程 4：第三方...
 * @param {string} [data.postId]
 * @param {string} [data.systemType]
 */
export function flowEngineSelector(data) {
  return request({
    url: `/workflow/engine/flowEngine/selector`,
    method: "post",
    data,
  });
}

/**
 * @description 流程引擎(教师可审批)
 * @param {string} [data.category]
 * @param {string} [data.flowId]
 * @param {string|number} [data.formType] - 表单类型 1-系统表单、2-动态表单 3纯表单 4 调查问卷
 * @param {string|number} [data.type] - 流程类型 1:发起流程,2:功能流程
 * @param {string|number} [data.userType] - 流程使用 1:老师,2:学生 3：其他流程 4：第三方...
 * @param {string} [data.postId]
 * @param {string} [data.systemType]
 */
export function teacherEngineList(data) {
  return request({
    url: `/workflow/engine/flowEngine/teacherEngineList`,
    method: "post",
    data,
  });
}

/**
 * @description 更新流程引擎
 */
export async function editFlowEngine(data) {
  return request({
    url: "/workflow/engine/flowEngine/update",
    method: "post",
    data,
  });
}

/**
 * @description 更新发起时间
 * @param {string} data.id
 * @param {number} [data.applyStartTime]
 * @param {number} [data.applyEndTime]
 */
export function updateApplyTime(data) {
  return request({
    url: "/workflow/engine/flowEngine/updateApplyTime",
    method: "post",
    data,
  });
}

/**
 * @description 批量启用或禁用
 * @param {string[]} data.ids - 流程id集合
 * @param {number|string} [data.lockedFlag] - 启用状态 0启动 1禁用
 */
export function updateBatchState(data) {
  return request({
    url: "/workflow/engine/flowEngine/updateBatchState",
    method: "post",
    data,
  });
}

/**
 * @description 审批转交
 * @param {number} data.type - 转交类型 0 角色 1人与人之间交接
 * @param {string[]} data.flowIds - 某个流程分类下的所有流程
 * @param {string[]} data.postIds - 岗位id集合
 * @param {string} data.preHandleId - 交接人A 将 a的数据交接给 b
 * @param {string[]} data.classIds - A名下的班级集合
 * @param {string} data.afterHandleId - 被交接人B 将 a的数据交接给 b
 */
export function updateOperator(data) {
  return request({
    url: "/workflow/engine/flowEngine/updateOperator",
    method: "post",
    data,
  });
}

/**
 * @description 替换IP
 * @param {string[]} data.ids - 某个流程分类下的所有流程
 * @param {string} data.formStr - 替换前
 * @param {string} data.toStr - 替换后
 */
export function replaceFlowEngineTemplateJson(data) {
  return request({
    url: `/workflow/engine/flowEngine/updateReplaceFlowTemplateJson`,
    method: "post",
    data,
  });
}

/**
 * @description 导入申请表：系统流程使用
 * @param {string} params.flowId
 * @param {string} params.templateFileId
 */
export function updateFlowEngineTemplateFileId(params) {
  return request({
    url: `/workflow/engine/flowEngine/updateTemplateFileId`,
    params,
  });
}
